import "./Footer.scss";
import logo from "../../Assets/logo.jpg";
import map from "../../Assets/map.png";
import { HashLink, NavHashLink } from "react-router-hash-link";

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer id="footer" className="section-footer">
      <div className="container-footer">
        <div className="footer-top">
          <div className="footer-logo">
            <HashLink smooth to="/">
              <img src={logo} alt="logo The Lagoon Park" />
            </HashLink>
            <h3 className="footer-logo-title">Marketing Gallery</h3>
            <div className="footer-logo-text">Bukit Golf Riverside</div>
            <div className="footer-contact">
              Contact Us : +6281220003574 - Lenny
            </div>
            <a href="/privacy-policy" className="footer-logo-text">
              Privacy Policy
            </a>
          </div>
          <div className="footer-sitemap">
            <div className="footer-site-link">
              <div className="footer-menu">
                PETA SITUS
                <li className="nav-item">
                  <NavHashLink smooth to="/#about" className="nav-links">
                    About us
                  </NavHashLink>
                </li>
                <li className="nav-item">
                  <NavHashLink smooth to="/#promo" className="nav-links">
                    Promo
                  </NavHashLink>
                </li>
                <li className="nav-item">
                  <NavHashLink smooth to="/#rumah" className="nav-links">
                    Residentials
                  </NavHashLink>
                </li>
                <li className="nav-item">
                  <NavHashLink smooth to="/#fasilitas" className="nav-links">
                    Facilities
                  </NavHashLink>
                </li>
                <li className="nav-item">
                  <NavHashLink smooth to="/#surrounding" className="nav-links">
                    Surrounding Area
                  </NavHashLink>
                </li>
                <li className="nav-item" onClick={scrollToTop}>
                  <a href="/" className="nav-links">
                    Back to Top
                  </a>
                </li>
              </div>
              <div className="footer-map">
                <div className="footer-map-title">LOKASI</div>
                <img
                  src={map}
                  alt="map The Lagoon Park"
                  className="footer-map-img"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="footer-rights">
          © {new Date().getFullYear()} Bukit Golf Riverside . All Rights
          Reserved.
          <div className="footer-powered">Powered by : Linktown</div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
